export default __webpack_public_path__ + "static/media/meraki_hero.69e9bd07.svg";